import { useState, useEffect } from "react";
import DonutWidget from "./DonutWidget";
import styles from "./leasegraph.module.css";
import { styled } from "@mui/material/styles";
import { Tooltip } from "@mui/material";
import { tooltipClasses } from "@mui/material/Tooltip";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";

const BGColor = [
  "#00BFFF",
  "#32CD32",
  "#FFC107",
  "#DC143C",
  "#FFDAB9",
  "#40E0D0",
  "#FFA07A",
  "#0027ED",
  "#F6FF00",
  "#FF69B4",
];

const LeaseGraph = ({ filterData }) => {
  const BootstrapTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: theme.palette.common.black,
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.common.black,
      fontSize: 13,
    },
  }));
  const { getAccessTokenSilently } = useAuth0();
  const [chartData, setChartData] = useState(null);

  useEffect(() => {
    async function getLeases() {
      const token = await getAccessTokenSilently({
        audience: process.env.REACT_APP_AUTH0_AUDIENCE,
      });

      let params = {};

      if (filterData?.property !== "" && filterData?.property !== "all") {
        params = { ...params, property_id: filterData?.property };
      }

      if (filterData?.apartment !== "" && filterData?.apartment !== "all") {
        params = { ...params, apt_id: filterData?.apartment };
      }

      if (filterData?.status !== "" && filterData?.status !== "all") {
        params = { ...params, status: filterData?.status };
      }

      axios(process.env.REACT_APP_PAYMENT_API_URL + "v1/lease-chart-data", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: params,
      })
        .then((response) => {
          setChartData(response.data.data);
        })
        .catch((error) => { });
    }
    getLeases();
  }, [getAccessTokenSilently, filterData]);

  return (
    chartData && (
      <>
        {chartData?.total > 0 && (<><div className={`${styles.ChartMainSec}`}>
          <div className={`${styles.TotalIncomeSec}`}>
            <p className={`${styles.Amount}`}>${chartData?.total_f}</p>
            <p className={`${styles.Text}`}>Projected Rent Roll</p>
            <p className={`${styles.Text2}`}>
              ${chartData?.occupied_f} Occupied
            </p>
            <p className={`${styles.Text2}`}>${chartData?.vacant_f} Vacant</p>
          </div>
          <div className={`${styles.ChartSec}`}>
            <DonutWidget chartData={chartData} />
          </div>
        </div>
        <div className={`${styles.ChartListCatMain}`}>
          {chartData &&
            chartData?.properties?.map((c, i) => {
              const total = c?.total_f || 0;
              const completed = c?.occupied_f || 0;
              const pending = c?.vacant_f || 0;
              const formatedTotal = parseFloat(
                (c?.total_f || "0")?.replace(/,/g, "")
              );
              const formatedCompleted = parseFloat(
                (c?.occupied_f || "0")?.replace(/,/g, "")
              );
              const formatedPending = parseFloat(
                (c?.vacant_f || "0")?.replace(/,/g, "")
              );
              const completedPercent = total
                ? (formatedCompleted / formatedTotal) * 100
                : 0;
              const pendingPercent = total
                ? (formatedPending / formatedTotal) * 100
                : 0;

              return (
                <div className={styles.ChartListCat} key={i}>
                  <p>
                    {c?.title} <span>${total.toLocaleString()}</span>
                  </p>
                  <div className={styles.ChartProgressTrack}>
                    <BootstrapTooltip
                      title={
                        <div className={styles.IncomeLineTooltip}>
                          <p>Occupied: ${completed.toLocaleString()}</p>
                        </div>
                      }
                    >
                      <div
                        style={{
                          width: `${completedPercent}%`,
                          backgroundColor: BGColor[i],
                          cursor: "pointer",
                        }}
                      ></div>
                    </BootstrapTooltip>
                    <BootstrapTooltip
                      title={
                        <div className={styles.IncomeLineTooltip}>
                          <p>Vacant: ${pending.toLocaleString()}</p>
                        </div>
                      }
                    >
                      <div
                        style={{
                          width: `${pendingPercent}%`,
                          backgroundColor: BGColor[i],
                          cursor: "pointer",
                          filter: 'brightness(0.75)'
                        }}
                      ></div>
                    </BootstrapTooltip>
                  </div>
                </div>
              );
            })}
          </div></>)}
        {chartData?.total === 0 &&
          <div className={`${styles.NoDataMain}`}>
            <div className={`${styles.NoDataIMG}`}>
              <img src="/static/img/no-lease.png" alt="No Data" />
            </div>
            <p className={`${styles.NoDataText}`}>Empty wallet!</p>
            <p className={`${styles.NoDataTextSub}`}>Looks like no payments have been made</p>
          </div>
        }
      </>
    )
  );
};

export default LeaseGraph;
